import * as lookups from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { FilterMarketProps } from './FilterMarket.types';

const FilterMarket: React.FC<FilterMarketProps> = ({ changeFilters, market }) => {
  const onLoadLookupData: AsyncSelectLoadDataHandler<CodeNameModel> = async (_, query) => {
    try {
      if (query.length < 2) {
        return [];
      }

      return await lookups.getMarketLookupSuggestions(cancelFunctions, query);
    } catch (error) {
      return [];
    }
  };

  const onSelect: SelectHandler<CodeNameModel> = (_, value: CodeNameModel) => {
    changeFilters({
      market: value,
    });
  };

  return (
    <AsyncSelect
      dataTestId="market-search"
      name="market"
      loadData={onLoadLookupData}
      onSelect={onSelect}
      placeholder="Search market"
      selectedValue={market}
    />
  );
};

export default FilterMarket;
